import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsDown: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm7 6 5 5 5-5' }],
    ['path', { d: 'm7 13 5 5 5-5' }],
  ],
];

export default ChevronsDown;
